import { ChangeEvent, FC, memo } from 'react';
import { RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import clsx from 'clsx';

interface IProps {
  options: { value: string; text: string }[];
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const JobDeliveryMethodSelector: FC<IProps> = ({ options, value, onChange }) => (
  <>
    <Typography variant="body2">How would you like to receive applications for this job listing?</Typography>
    <RadioGroup
      className="cpg-tile-group"
      sx={{ mt: 1, mb: 3, gap: 1 }}
      value={value}
      onChange={onChange}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          className={clsx('cpg-choice-tile', {
            'cpg-choice-tile--selected': option.value === value
          })}
          control={
            (
              <Radio
                sx={{
                  '& .MuiSvgIcon-root': {
                    width: '16.7px',
                    height: '16.7px',
                  },
                }}
              />
            )
          }
          label={option.text}
          value={option.value}
          sx={{
            '.MuiFormControlLabel-label': {
              fontSize: '0.875rem',
              fontWeight: 400,
              lineHeight: 1.57,
            },
            '.PrivateSwitchBase-root': { py: 0, pr: 1 },
          }}
        />
      ))}
    </RadioGroup>
  </>
);

export default memo(JobDeliveryMethodSelector);
